module.exports = __webpack_public_path__ + "img/collection-engagementRingsCordial@2x.6ba97e7.webp";